import React from 'react';
import { useHistory, Redirect } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  Button,
  Menu,
  MenuItem,
  Typography,
  Select,
  InputAdornment,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { Menu as MenuIcon, AccountCircle, Language as LanguageIcon } from '@material-ui/icons';
import AppContext from 'contexts/AppContext';
import 'styles/components/AppHeader.scss';
import '../translation/config';
import ProfileTypes from 'types/enums/ProfileTypes';

export default (): JSX.Element => {
  const history = useHistory();
  const { authData, setAuthData } = React.useContext(AppContext);
  const [toggleDrawer, setToggleDrawer] = React.useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { t, i18n } = useTranslation();
  const languages = [
    { id: 'es', description: 'Español' },
    { id: 'en', description: 'English' },
    { id: 'pt', description: 'Português' },
  ];

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const goToPage = (route: string) => {
    history.push(route);
    setToggleDrawer(false);
  };

  const handleChangeLanguage = (language: string) => {
    i18n.changeLanguage(language);
    localStorage['language'] = language;
  };

  const LanguageSelector = (): JSX.Element => {
    return (
      <Select
        className="language-selector"
        displayEmpty
        startAdornment={
          <InputAdornment position="start">
            <LanguageIcon />
          </InputAdornment>
        }
        style={{ color: '#FFF' }}
      >
        {/* <MenuItem>{t('app-header-language')}</MenuItem> */}
        <MenuItem>{t('language')}</MenuItem>
        {languages?.map((language) => (
          <MenuItem
            onClick={() => {
              handleChangeLanguage(language.id);
            }}
            value={language.id}
            key={language.id}
          >
            {language.description}
          </MenuItem>
        ))}
      </Select>
    );
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <>
          {authData && (
            <>
              <IconButton
                edge="start"
                color="inherit"
                onClick={() => {
                  setToggleDrawer(true);
                }}
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="h6" className="app-bar-title">
                {t('menu')}
              </Typography>
              <div>
                <IconButton onClick={handleMenu} color="inherit" edge="end">
                  <AccountCircle />
                </IconButton>
                <Menu id="menu-appbar" anchorEl={anchorEl} open={open} onClose={handleClose}>
                  <MenuItem
                    onClick={() => {
                      goToPage('/private/common/change-password');
                    }}
                  >
                    {t('change-password')}
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setAuthData(null);
                      localStorage.removeItem('auth-data');
                      handleClose();
                      return <Redirect to="/public/login" />;
                    }}
                  >
                    {t('close-session')}
                  </MenuItem>
                </Menu>
              </div>
            </>
          )}

          <LanguageSelector />
        </>
      </Toolbar>
      <Drawer
        anchor="left"
        open={toggleDrawer}
        onClose={() => {
          setToggleDrawer(false);
        }}
      >
        <Button
          onClick={() => {
            goToPage('/private/welcome');
          }}
        >
          {t('home')}
        </Button>

        {authData?.user.profileTypeId === ProfileTypes.Admin && (
          <Button
            onClick={() => {
              goToPage('/private/venues');
            }}
          >
            {t('venues')}
          </Button>
        )}

        {(authData?.user.showUserSection ||
          authData?.user.showUserSplashSection ||
          authData?.user.profileTypeId === ProfileTypes.Admin) && (
          <Button
            onClick={() => {
              goToPage('/private/users');
            }}
          >
            {t('users')}
          </Button>
        )}

        {authData?.user.profileTypeId === ProfileTypes.Admin && (
          <Button
            onClick={() => {
              goToPage('/private/user-editors');
            }}
          >
            {t('venue-editors')}
          </Button>
        )}

        {(authData?.user.showSplashSection ||
          authData?.user.showUserSplashSection ||
          authData?.user.profileTypeId === ProfileTypes.Admin) && (
          <Button
            onClick={() => {
              goToPage('/private/splashes');
            }}
          >
            {t('splashes')}
          </Button>
        )}
      </Drawer>
    </AppBar>
  );
};
